import { render, staticRenderFns } from "./MetaTagDescription.vue?vue&type=template&id=98ca7f64&"
import script from "./MetaTagDescription.vue?vue&type=script&lang=js&"
export * from "./MetaTagDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports